import TypesenseInstantsearchAdapter from "typesense-instantsearch-adapter";

import { TypesenseConfig } from "../../../utils/third-party/typesense";

export const typesenseAdapter = new TypesenseInstantsearchAdapter({
    server: TypesenseConfig,
    additionalSearchParameters: {
        query_by: "name,discountCode",
        facet_by: "type,status,discountCode,createdAt",
        typo_tokens_threshold: 3,
        per_page: 20,
    },
});

export const FREEBIE_RULES_COLLECTION = `${process.env.REACT_APP_TYPESENSE_PREFIX}freebie-rules`;
